//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifSubSysEdit: {
      type: Boolean,
      default: false
    },
    typelist: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    subformSysdata: null
  },
  data: function data() {
    return {
      formSys: {
        systemType: null,
        baseUrl: null
      },
      formSysdefault: {
        systemType: null,
        baseUrl: null
      },
      rules: {
        systemType: [{
          required: true,
          message: '请选择系统类型',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    if (this.ifSubSysEdit) {
      this.formSys = this.subformSysdata;
    } else {
      this.formSys = this.formSysdefault;
    }
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('cancelSubSysEdit');
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    },
    commit: function commit() {
      var _this = this;
      this.$refs.formSys.validate(function (valid) {
        if (valid) {
          _this.$emit('subSysEditSubmit', {
            bool: true,
            formData: _this.formSys
          });
        } else {
          _this.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    }
  }
};